import { backendPublicPath } from "@/api/servicePaths";

import FETCHRAW from "../fetchRaw";

export const getDataSearch = (params?, dataSearch?) =>
  FETCHRAW({
    type: "apiurl",
    path: backendPublicPath(`/search/?filter=${dataSearch}`),
    method: "get",
    params
  });
